import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash'
import { isNullOrUndefined } from 'util';
import { MasterSummaryPDModel } from '../../../../models/survey/survey.model';
import { SortType } from '../../../constants/sort.constants';
import { ROSE_CHART_COLORS } from '../../../helpers/chart-helper';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'app-gauge-ring-chart',
  templateUrl: './gauge-ring-chart.component.html',
  styleUrls: ['./gauge-ring-chart.component.less']
})
export class GaugeRingChartComponent implements OnInit {

  @Input() dataSource: MasterSummaryPDModel;
  @Input("chartJ") chartJ: number;
  @Input() isSelectedAllResponses: boolean;

  chartInstance: any;
  isLoading = false;
  chartOption: any;
  oldDataSource: string;
  sortType = SortType.RESET;
  initOpts = {
    renderer: 'svg',
    width: 920,
    height: 400
  };
  
  constructor(private communicationService: CommunicationService) {
  }

  ngOnInit() {
    this.communicationService.scrollDataChanged.subscribe(() => {
        if (this.oldDataSource !== JSON.stringify(this.dataSource)) {
            this.oldDataSource = JSON.stringify(this.dataSource);
            this.initChart();
        }
    });
    this.communicationService.sortCompareChartsChanged.subscribe((response) => {
      if(response.sortType !== this.sortType) {
        this.sortType = response.sortType;
        if (this.sortType === SortType.RESET) {
          this.initChart();
        } else {
          this.reloadChart();
        }
      }
    });
    this.initChart();
  }

  onChartInit(instance) {
    this.chartInstance = instance;
  }

  private reloadChart() {
    if (this.chartInstance && this.chartOption) {
      if (this.chartOption.series && this.chartOption.series.length > 0) {
        let gaugeData = this.chartOption.series[0].data;  
        const sortOrder = this.sortType === SortType.ASCENDING ? 'asc' : 'desc';
        if (gaugeData && gaugeData.length > 0) {
          gaugeData = _.orderBy(gaugeData, ['value'],[sortOrder]);
          gaugeData = this.setOffsetSeries(gaugeData);
          this.chartInstance.setOption({
            series: {
              data: gaugeData
            }
          });
        }
      }
    }
  }

  private initChart() {
    this.isLoading = true;
    let dataSeries = [];
    let maxScale = 0;
    let colorIndex = 0;
    if (this.isSelectedAllResponses) {
      dataSeries = this.pushGaugeData(dataSeries, 'All responses', this.dataSource.listQuestionModel[this.chartJ], colorIndex);
      maxScale = this.getMaxScale(this.dataSource.listQuestionModel[this.chartJ], maxScale);
      colorIndex = this.getNextColorIndex(colorIndex);
    }
    if (this.dataSource.listSurveyVersionQuestion && this.dataSource.listSurveyVersionQuestion.length > 0) {
      this.dataSource.listSurveyVersionQuestion.forEach(question => {
        dataSeries = this.pushGaugeData(dataSeries, question.surveyName, question.listQuestionModel[this.chartJ], colorIndex);
        maxScale = this.getMaxScale(question.listQuestionModel[this.chartJ], maxScale);
        colorIndex = this.getNextColorIndex(colorIndex);
      })
    }
    if (this.dataSource.listSurveyCutQuestion && this.dataSource.listSurveyCutQuestion.length > 0) {
      this.dataSource.listSurveyCutQuestion.forEach(question => {
        dataSeries = this.pushGaugeData(dataSeries, question.surveyName, question.listQuestionModel[this.chartJ], colorIndex);
        maxScale = this.getMaxScale(question.listQuestionModel[this.chartJ], maxScale);
        colorIndex = this.getNextColorIndex(colorIndex);
      })
    }

    const barWidth = 17;
    if (dataSeries.length > 1) {
      dataSeries = this.setOffsetSeries(dataSeries);
      this.isLoading = false;
    }

    maxScale = (maxScale > 0 && maxScale < 100) ? maxScale : 100;
    const gaugeData = dataSeries.length > 1 ? dataSeries : [];
    this.chartOption = {
      tooltip: {
        trigger: 'item',
        borderRadius: 0,
        shadowColor: null,
        borderColor: '#5E5E5E',
        axisPointer: {
          type: 'shadow'
        },
        position: function (point, params, dom, rect, size) {
          return {top: point[1] + 10, left: 300};
        }
      },
      series: [
        {
          type: 'gauge',
          max: maxScale,
          radius: '100%',
          center: ['50%', '50%'],
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false
          },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {
              borderWidth: 1,
              borderColor: '#464646'
            }
          },
          axisLine: {
            lineStyle: {
              width: barWidth * dataSeries.length
            }
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            distance: 50
          },
          data: gaugeData,
          title: {
            fontSize: 12,
            width: 256,
            padding: [0, 0, 0, 32],
            overflow: 'truncate',
            ellipsis: '...'
          },
          detail: {
            width: 50,
            padding: [0, 0, 0, 32],
            height: 14,
            fontSize: 14,
            color: 'auto',
            borderColor: 'auto',
            borderRadius: 0,
            borderWidth: 0,
            formatter: '{value}'
          }
        }
      ]
    };
  }

  private pushGaugeData(dataSeries, surveyName, question, colorIndex) {
    if (!isNullOrUndefined(question)) {
      dataSeries.push({
        value: this.getAnswerValue(question),
        name: surveyName,
        itemStyle: {color: ROSE_CHART_COLORS[colorIndex]},
        title: {
          offsetCenter: ['0%', '0%']
        },
        detail: {
          valueAnimation: true,
          offsetCenter: ['0%', '0%']
        }
      });
    }
    return dataSeries;
  }

  private getAnswerValue(item) {
    return (item.averageValue && item.averageValue > 0 ) ? item.averageValue.toFixed(1) : 0
  }

  private setOffset(data, titleOffset, detailOffset) {
    data.title.offsetCenter = ['100%', `${titleOffset}%`];
    data.detail.offsetCenter = ['100%', `${detailOffset}%`];
  }

  private getNextColorIndex(colorIndex) {
    colorIndex++;
    if (colorIndex === ROSE_CHART_COLORS.length) {
      colorIndex = 0;
    }
    return colorIndex;
  }

  private setOffsetSeries(dataSeries) {
    const titleOffsetCenter = dataSeries.length % 2 === 0 ? 8 : -2;
    const detailOffsetCenter = dataSeries.length % 2 === 0 ? 18 : 8;
    const distance = 24;

    const idx = Math.floor(dataSeries.length / 2);
    let titleOffset = titleOffsetCenter;
    let detailOffset = detailOffsetCenter;
    this.setOffset(dataSeries[idx], titleOffset, detailOffset);
    for (let i = idx + 1; i < dataSeries.length; i++) {
      titleOffset = titleOffset + distance;
      detailOffset = detailOffset + distance;
      this.setOffset(dataSeries[i], titleOffset, detailOffset);
    }

    titleOffset = titleOffsetCenter;
    detailOffset = detailOffsetCenter;
    for (let i = idx - 1; i >= 0; i--) {
      titleOffset = titleOffset - distance;
      detailOffset = detailOffset - distance;
      this.setOffset(dataSeries[i], titleOffset, detailOffset);
    }
    return dataSeries;
  }

  private getMaxScale(question, curMax) {
    let maxScale = 0;
    if (!isNullOrUndefined(question)) {
      const averageValue = (question.averageValue && question.averageValue > 0) ? Math.ceil(question.averageValue) : 0;
      if (question.listAnswerModel && question.listAnswerModel.length > 0) {
        const listAnswer = question.listAnswerModel.filter(s => !isNaN(s.answerName)).map(x => parseInt(x.answerName));
        maxScale = listAnswer && listAnswer.length > 0 ? Math.max(...listAnswer) : 0;
        if (maxScale < averageValue) {
          maxScale = averageValue;
        }
      } else if (question.maxAnswer > 0) {
        maxScale = question.maxAnswer;
      } else {
        maxScale = averageValue;
      }
    }
    return curMax < maxScale ? maxScale : curMax;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/gauge-ring-chart/gauge-ring-chart.component.ts